export default __webpack_public_path__ + "static/media/Hh.6822d25b.wav";